import React, { useContext } from "react";
import { History } from "history";
import { get } from "lodash";
//  @ts-ignore
import Context from "@fdr-mar/promos-context";
import { Button } from "@tvg/design-system";
import { BackButtonContainer } from "./styled-components";

const { PathContext } = Context;

interface Props {
  history: History;
}

interface PathContextType {
  setContent: (slug: string) => void;
}

const BackButton = ({ history }: Props) => {
  const { setContent } = useContext<PathContextType>(PathContext);
  const slug = get(history, "location.state.pageOrigin", "promos");

  return (
    <BackButtonContainer>
      <Button
        size="m"
        variant="tertiary"
        icon="chevronLeft"
        onPress={() => {
          history.back();
          setContent(slug);
        }}
        qaLabel="back-btn"
      >
        Back
      </Button>
    </BackButtonContainer>
  );
};

export default BackButton;
